export default __webpack_public_path__ + "static/media/comment-love-o.6e9ed207.svg";